import type { Dashboard } from '@clockwise/clients/dashboards';
import { ShareDialog } from '@/components/custom/share-dialog';
import { dashboardsApi } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface Props {
  dashboard: Dashboard;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Who may open this dashboard.
 *
 * Sharing a dashboard hands over an ARRANGEMENT, not the reports inside it.
 * Each tile still resolves its report under the viewer's own reach, so a
 * recipient who was never given an underlying report sees a tombstone in that
 * tile rather than its contents — which is what keeps `dashboard.share` from
 * being a back door around `report.share`.
 */
export function ShareDashboardDialog({ dashboard, open, onOpenChange }: Props) {
  return (
    <ShareDialog
      subject={dashboard}
      noun="dashboard"
      onSave={(shares) => dashboardsApi.replaceShares(dashboard.id, shares)}
      invalidateKey={queryKeys.dashboards.all}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
}
